/**
 * Full-screen maintenance/release screen shown when the `release-maintenance-page`
 * feature flag is enabled. It replaces the entire app (login + all routes) so users
 * see a clear scheduled-maintenance message instead of a broken/error page during a
 * production release.
 */
export function MaintenancePage() {
  return (
    <div className="min-h-screen w-full bg-white grid place-items-center p-6">
      <div className="flex flex-col items-center text-center max-w-md">
        <img src="/logo.svg" alt="Air Reading Logo" className="h-12 md:h-16 mb-8" />
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Website maintenance</h1>
        <p className="mt-4 text-base md:text-lg text-gray-500">This site is undergoing scheduled maintenance</p>
        <p className="text-base md:text-lg text-gray-500">We expect to be back online shortly</p>
      </div>
    </div>
  );
}
